export default "__VITE_ASSET__lhAZ$1iu__"